
























import Vue from "vue";
import { Watch } from "vue-property-decorator";
import { Dashboard, DashLayout, DashItem } from "vue-responsive-dash";
import { Component } from "vue-property-decorator";
import { AppConstants as _app } from "@/shared/app.constants";
import AllocationReport from "./Reports/AllocationRepot.vue";
import ImplProgressReport from "./Reports/ImplProgressReport.vue";
import LeftNavigationComponent from "../../Workspace/Components/LeftNavigation.vue";
import "@/styles/iucn/filter.css";
import "@/styles/iucn/main-content.css";

@Component({
  components: {
      AllocationReport,
      LeftNavigationComponent,
      ImplProgressReport
  }
})
export default class BudgetReportComponent extends Vue {

  showSideBar: boolean = false;
  selectedKey: string = Object.keys(this.subSections.properties)[0];
  

  /** Return budget reports */
  get subSections() {
      return _app.budgetReportSections;
  }

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }

    /** report changed */
  reportChanged(key: string) {
      this.selectedKey = key;
      this.$router.push({
        name: "budgetReports",
        params: { report: key } 
      });
  }

  @Watch("$route", { immediate: true, deep: true })
    onUrlChange(changedRoute: any, previousRoute) {
        if(changedRoute && changedRoute.name === 'budgetReports') {
            if(changedRoute.params.report) {
                this.selectedKey = changedRoute.params.report;
            }
        }
    }
    
}
